import { render, staticRenderFns } from "./DisputedCallsCard.vue?vue&type=template&id=85fc9002&scoped=true"
import script from "./DisputedCallsCard.vue?vue&type=script&lang=js"
export * from "./DisputedCallsCard.vue?vue&type=script&lang=js"
import style0 from "./DisputedCallsCard.vue?vue&type=style&index=0&id=85fc9002&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85fc9002",
  null
  
)

export default component.exports